import Color from 'color';
import { FC } from 'react';
import styled from 'styled-components';

import { VersionDiffChangeType } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { FlowEditorHighlightColorVariant } from 'dashboard/components/FlowEditorNodeHighlighter';

const DiffLabelSpan = styled.span.attrs<{
  changeType?: VersionDiffChangeType | null;
}>((props) => {
  if (props?.changeType) {
    const changeColor = FlowEditorHighlightColorVariant[props.changeType];
    const highlightColor = Color(changeColor).rgb();

    const highlightColorRgb = `${highlightColor.red()}, ${highlightColor.green()}, ${highlightColor.blue()}`;

    return {
      style: {
        backgroundColor: ` rgba(${highlightColorRgb}, 0.4)`,
      },
    };
  }
})<{ changeType?: VersionDiffChangeType | null }>``;

const DiffLabel: FC<{ changeType: VersionDiffChangeType | null }> = ({ children, changeType }) => {
  return <DiffLabelSpan changeType={changeType}>{children}</DiffLabelSpan>;
};

export default DiffLabel;
